import React from 'react';
import styled from 'styled-components';
import mergeClassNames from '../../lib/style-helpers/merge-class-name';
import { FontType, FontSize } from '../../../../config/theme/types/themeTypes';
import { StyledWithChildrenProps } from '../../types/StyledWithChildrenProps';

function H6({
  className,
  children,
  ...props
}: StyledWithChildrenProps) {
  return (
    <Header
      className={mergeClassNames('H6', className)}
      {...props}
    >
      {children}
    </Header>
  );
}

const Header = styled.h6 < StyledWithChildrenProps > `
  ${({ theme }) => theme.font(FontType.Strong, FontSize.H6)}
`;

export default H6;
